import { createFileRoute } from '@tanstack/react-router'
import { PageHeader } from '@/shared/ui/page-header'
import { InboxView } from '@/widgets/inbox-view'

export const Route = createFileRoute('/inbox')({
  component: InboxPage,
  head: () => ({ meta: [{ title: 'Инбокс · STIT Task' }] }),
})

function InboxPage() {
  return (
    <div className="container-x px-4 py-8 sm:px-6 sm:py-10">
      <PageHeader title="Инбокс" eyebrow="Уведомления" />
      <div className="mt-8">
        <InboxView />
      </div>
    </div>
  )
}
